import { ApiError } from "../../api/client";

export function currentMonth(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

export function firstOfMonth(month: string): string {
  return `${month}-01`;
}

export function monthOf(isoDate: string): string {
  return isoDate.slice(0, 7);
}

export function monthName(month: string): string {
  return new Date(`${month}-15T00:00:00Z`).toLocaleDateString("en-US", {
    month: "long",
    year: "numeric",
    timeZone: "UTC",
  });
}

export function shortDateLabel(isoDate: string): string {
  return new Date(`${isoDate}T00:00:00Z`).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    timeZone: "UTC",
  });
}

export function defaultDate(month: string): string {
  if (month !== currentMonth()) return firstOfMonth(month);
  const d = new Date();
  return `${month}-${String(d.getDate()).padStart(2, "0")}`;
}

export function recordedLabel(utc: string | undefined): string {
  if (!utc) return "";
  const d = new Date(/[zZ]|[+-]\d\d:\d\d$/.test(utc) ? utc : `${utc}Z`);
  if (isNaN(d.getTime())) return utc;
  return d.toLocaleString([], { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
}

export function orNull(value: string | undefined): string | null {
  const trimmed = (value ?? "").trim();
  return trimmed ? trimmed : null;
}

interface ValidationDetail {
  loc?: (string | number)[];
  msg?: string;
}

export function errorMessage(err: unknown): string {
  if (err instanceof ApiError) {
    const detail = (err.body as { detail?: unknown } | null)?.detail;
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) {
      return (detail as ValidationDetail[])
        .map((d) => {
          const field = (d.loc ?? []).slice(1).join(".");
          return field ? `${field}: ${d.msg ?? "invalid"}` : (d.msg ?? "invalid");
        })
        .join("; ");
    }
    return `Request failed (${err.status}).`;
  }
  return err instanceof Error ? err.message : String(err);
}
